import LogCannon from '@ace-clublabs/log-cannon';
import { IUpdateEmailsRequest } from '@lib/types';
import axios from 'axios';
import { ErrorType } from '../../shared/types';
import CookieHelper from '../../utils/cookieHelper';
import { UpdateEmails } from '../contracts';
import { createAxiosConfig } from '../mockHelper';

export const UpdateEmailsApi =
  (endpoint: string): UpdateEmails =>
  async (request: IUpdateEmailsRequest) => {
    try {
      const scenario = CookieHelper.getCookie('scenario');
      LogCannon.blast('UpdateEmailsApi scenario', { scenario });

      LogCannon.blast('UpdateEmailsApi start', {
        endpoint,
        membershipNumber: request.membershipNumber,
        zipCode: request.zipCode,
      });
      const response = await axios.post(endpoint, request, createAxiosConfig(scenario, endpoint));
      LogCannon.blast('UpdateEmailsApi success');
      return Promise.resolve(response.data);
    } catch (error: any) {
      LogCannon.error('UpdateEmailsApi error', { error: error?.message });
      if (error.response) {
        return Promise.reject({
          message: error.response.data?.message,
          requestId: error.response.data?.requestId,
          type: ErrorType.SYSTEM_ERROR,
        });
      } else {
        return Promise.reject({
          message: error,
        });
      }
    }
  };
